import axios from "axios";

export const urlBase = process.env.REACT_APP_API_URL;

const urlChat = `${urlBase}/public/v1/fe/`;
const urlChatV2 = `${urlBase}/public/v2/fe/`;

const urlResource = `${urlBase}/chatbot-resource-management-api/v1.0/`

const authHeaders = {
  Authorization: "Basic xxxxxxxxxxxxx",
  "Content-Type": "application/json;charset=UTF-8",
};

const channelConfig = async (data) => {
  try {
    const res = await axios.post(`${urlChat}channelConfig`, data, {
      headers: authHeaders,
    });
    return res.data;
  } catch (error) {
    console.error('channelConfig error:', error);
    throw error;
  }
};

const getChatHistories = async (conversationId, pageMessageHistory = {}) => {
  try {
    const res = await axios.get(`${urlChat}${conversationId}/messages`, {
        params: {
            page: pageMessageHistory,
            size: 20,
            sort: 'createdAt,desc'
        },
        headers: authHeaders,
    });
    return res.data;
  } catch (error) {
    console.error('getChatHistories error:', error);
    throw error;
  }
};

const sendMessageV1 = async (conversationId, data) => {
  try {
    const res = await axios.post(`${urlChat}${conversationId}/messagesv2`, data, {
      headers: authHeaders,
    });
    return res.data;
  } catch (error) {
    console.error('sendMessage error:', error);
    throw error;
  }
};

const sendMessageV2 = async (conversationId, text, titleFile, fileUrl = "", authHeaders = {}) => {
  const payload = {
    message: {
      text: text,
    },
  };

  if (fileUrl) {
    payload.message.attachments = [
      {
        type: "file",
        title: titleFile,
        payload: {
          url: fileUrl,
        },
      },
    ];
  }

  try {
    const res = await axios.post(`${urlChatV2}${conversationId}/messages`, payload, {
      headers: {
        "Content-Type": "application/json",
        ...authHeaders,
      },
    });
    return res.data;
  } catch (error) {
    console.error("sendMessageV2 error:", error);
    throw error;
  }
};

const updateLikeStatus = async (messageId, isLike) => {
  try {
    const res = await axios.post(
      `${urlChatV2}messages/${messageId}/action`,
      { isLike }, // true, false, hoặc null
      { headers: { "Content-Type": "application/json" } }
    );
    return res.data;
  } catch (error) {
    console.error("updateLikeStatus error", error);
    throw error;
  }
};

const getRandomSuggestedQuestions = async (topic = "international-trade", count) => {
  try {
    const res = await axios.get(
      `${urlChatV2}suggested-questions`,
      {
        params: { topic },
        headers: { "Content-Type": "application/json" }
      }
    );

    const questions = res.data?.questions || [];

    // Trộn mảng và lấy count câu ngẫu nhiên
    const randomQuestions = [...questions]
      .sort(() => Math.random() - 0.5)
      .slice(0, count);

    return randomQuestions;
  } catch (error) {
    console.error("getRandomSuggestedQuestions error", error);
    throw error;
  }
};

const downloadBotReply = async (content, date) => {
  try {
    const res = await axios.post(`${urlResource}chatbot-download-content`, {
        content,
        date,
      },
      {
        headers: {
        'x-api-key': 'vietrade-ai',
      }
    })
    return res.data;
  } catch (error) {
    console.error("downloadBotReply error", error);
    throw error;
  }
}

const ChatAPI = {
    channelConfig,
    getChatHistories,
    sendMessageV1,
    sendMessageV2,
    updateLikeStatus,
    getRandomSuggestedQuestions,
    downloadBotReply
}

export default ChatAPI